import styles from "./dropdown.module.css";
import { GoTriangleDown } from "react-icons/go";
import { HiInformationCircle } from "react-icons/hi";
import React, { useEffect, useState, useRef, useCallback } from "react";

function Dropdown({position, disabled, label, placeholder, itemsWidth, value, onValueChange, onValueChangeFormFalse, items, onUrlChange, nextUrl, callbackFunction, callbackLink, required, dropdownWidth, info}) {

  const dropdownRef = useRef(null);
  const labelRef = useRef(null);
  useOutsideAlerter(dropdownRef, labelRef);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [bottomPosition, setBottomPosition] = useState("");
  const [bottomPage, setBottomPage] = useState(window.innerHeight + window.scrollY);

  // useCallback atualiza o valor passado na outra página
  const handleChange = useCallback( newValue => {
    onValueChange(newValue);
    if (onValueChangeFormFalse) onValueChangeFormFalse(false);
    if (callbackFunction) callbackFunction(callbackLink+newValue.id);
    setOpenDropdown(false);
  }, [onValueChange]);

  async function handleDropdownSize() {
    if (openDropdown === false && !disabled) {
      await setOpenDropdown(true);
      if (bottomPosition < bottomPage){
        await setBottomPage(window.innerHeight + window.scrollY);
        await setBottomPosition(dropdownRef.current.getBoundingClientRect().bottom+window.scrollY+dropdownRef.current.offsetHeight);
      }
    }
  }

  const handleScrollData = useCallback( e => {
    if (nextUrl) {
      if ((e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) && (nextUrl !== "")){
        onUrlChange(nextUrl, false);
        e.target.scrollTo({
          top: e.target.scrollHeight - e.target.clientHeight - 10,
          behavior: "smooth"
        })
      }
    }
  }, [onUrlChange]);

  // Deteta quando clica fora do dropdown para fechá-lo
  function useOutsideAlerter(ref, labelRef) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target) && labelRef.current && !labelRef.current.contains(event.target)) {
          setOpenDropdown(false);
          setBottomPosition(10);
          setBottomPage(100);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div className={styles.form}>
      <div style={{opacity: disabled ? 0.7 : "", cursor: disabled ? "not-allowed" : "", width: dropdownWidth ? dropdownWidth : ""}} className={(value === "" && required) ? styles.dropdownNull : styles.dropdown}>
        { label === false ? "" : <p style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "8px"}}>{info ? <HiInformationCircle title={info} size={18} style={{cursor: "help"}} /> : ""}{label}</p> }
        <div ref={labelRef}className={styles.dropdownLabel} style={{color: value === "" ? "" : "var(--text-primary)", cursor: disabled ? "default" : "pointer", borderBottomLeftRadius: !label ? "4px" : "", borderTopLeftRadius: !label ? "4px" : "" }} onClick={() => handleDropdownSize()}>
          {value === "" ? placeholder : value.name}
          <GoTriangleDown size={14}/>
        </div>
      </div>
      {
        openDropdown && !disabled ?
        <div style={{position: position ? position : ""}} className={styles.dropdownItems}>
            <div ref={dropdownRef} className={bottomPosition >= bottomPage ? styles.itemsTop : styles.items} style={{ width: itemsWidth }} onScroll={(e) => { handleScrollData(e) }  }>
            {
              items.map((value) => (
                <div key={value.id} className={styles.item} onClick={() => handleChange(value) }>
                  {value.name}
                </div>
              ))
            }
            </div>
        </div>
        :
        <></>
      }
    </div>
  );
}

export default Dropdown;
